import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton, Box, CircularProgress } from '@mui/material';

const Loading = ({ width, height, showSpinner }) => {
  return (
    <Box position="relative" width={width} height={height}>
      {/* Skeleton di caricamento */}
      <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" />

      {/* Spinner sovrapposto */}
      {showSpinner && (
        <CircularProgress
          size={40}
          sx={{
            position: 'absolute',
            top: '25%',
            left: '40%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      )}
    </Box>
  );
};

// 🔹 PropTypes Validation
Loading.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.number,
  showSpinner: PropTypes.bool,
};

// 🔹 Default Props
Loading.defaultProps = {
  width: '100%',
  height: 100,
  showSpinner: true,
};

export default Loading;
